function Activate() {

    this.name = 'activate';
}

export {Activate};
